import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import { CircularProgress, Box } from '@mui/material';
import { useSnackbar } from '../../contexts/CustomSnackbarContext';
import { authenticateSupabase } from 'redux-store/currentUserActions';

const SupabaseComponent = ({projectId}) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { openSnackbar } = useSnackbar();

  useEffect(() => {
    const performSupabaseAuthentication = async () => {
      const queryParams = new URLSearchParams(location.search);
      const code = queryParams.get('code');

      if (!code) {
        openSnackbar({ message: 'Code is missing', severity: 'error' });
        history.push('/collections');
        return;
      }

      try {
        const response = await dispatch(authenticateSupabase({code, projectId})).unwrap();

        if (response.message === 'Supabase authentication successful') {
          history.push('/collections');
        } else {
          throw new Error('Supabase authentication failed');
        }
      } catch (error) {
        history.push('/collections');
      }
    };

    performSupabaseAuthentication();
  }, [dispatch, history, location, openSnackbar]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      <CircularProgress />
    </Box>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    projectId: state.common.selectedProject?.id,
  };
}

export default connect(mapStateToProps)(SupabaseComponent);
